import React from "react";

const SvgIcnListDevice = props => (
  <svg
    id="icn_list_device_svg__\u30EC\u30A4\u30E4\u30FC_1"
    data-name="\u30EC\u30A4\u30E4\u30FC 1"
    width={24}
    height={24}
    {...props}
  >
    <defs>
      <style>
        {
          ".icn_list_device_svg__cls-1{fill:#4a4b4c}.icn_list_device_svg__cls-2{fill:#fff}"
        }
      </style>
    </defs>
    <path
      className="icn_list_device_svg__cls-1"
      d="M3.93 14V5h15v1h2v-.91A2.08 2.08 0 0 0 18.85 3H4a2.08 2.08 0 0 0-2.07 2.09v8.84A2.08 2.08 0 0 0 4 16h5.93v-2z"
    />
    <path
      className="icn_list_device_svg__cls-2"
      d="M13 6h6V5H4v9h6V9a3 3 0 0 1 3-3z"
    />
    <rect
      className="icn_list_device_svg__cls-1"
      x={11.99}
      y={8.01}
      width={10}
      height={14}
      rx={1}
      ry={1}
    />
    <path
      className="icn_list_device_svg__cls-2"
      d="M13.99 10.01h5.98v9h-5.98z"
    />
    <rect
      className="icn_list_device_svg__cls-2"
      x={16}
      y={20}
      width={2}
      height={1}
      rx={0.5}
      ry={0.5}
    />
  </svg>
);

export default SvgIcnListDevice;
